module.exports = __webpack_public_path__ + "img/pad_icon_3.cf42152f.png";